import { Collection } from 'ckeditor5/src/utils';
import { Model } from 'ckeditor5/src/ui';

export default function getDropdownItemsDefinitions(placeholders) {

	const itemDefinitions = new Collection();

	for ( const item of placeholders ) {
		const definition = {
			type: 'button',
			model: new Model( {
				commandParam: item,
				label: item.text,
				withText: true,
			} )
		};

		// Add the item definition to the collection.
		itemDefinitions.add( definition );
	}

	return itemDefinitions;
}